export const handleCloseSnackbar = (setSnackbarMessage, setSnackbarErrorMessage) => {
    setSnackbarMessage(null);
    setSnackbarErrorMessage(null);
};
